<div [height]="20"></div>
<ng-container *ngIf="forgottenPassState === 'completeEmail'">
    <div class="complete-email-pane shadow">
        <div [height]="30"></div>
        <div class="header-font centered-txt b1Color" i18n>{{ 'FORGOTTEN_YOUR_PASSWORD' | translate }}?</div>

        <div class="cnt-column-centered">

            <div [height]="20"></div>
            <input #emailInput id="email" [(ngModel)]="email" class="default-input" type="email" name="email"
                   i18n-placeholder [placeholder]="'ENTER_EMAIL_ADDRESS' | translate" autocomplete="off" [height]="50" maxlength="100"
                   (focusout)="validateEmail()" data-testid="regEmail-edit-input">
            <div #emailWrongMsg class="validation-failed-message">​</div>

            <div [height]="5"></div>
            <simple-btn class="signup-btn"
                        [hoverTextColor]="'white'"
                        [backgroundFillCls]="'o2Background'"
                        [hoverFillCls]="'o1Background'"
                        [boxShadowCls]="'primary-shadow'"
                        [text]="resetFormButtonText | translate"
                        [textCls]="'very-large-btn-text'"
                        [height]="50"
                        [cornerRadius]="30"
                        [horizontalPadding]="20"
                        (click)="sendLetter()"
                        data-testid="trialTimerUpgradeBtn">
            </simple-btn>
            <div [height]="20"></div>

        </div>

        <div [height]="12"></div>

    </div>
    <div class="bottom-links-container" style="max-width: 400px !important">
        <a class="bottom-links" (click)="goToSignIn()" i18n>{{ 'LOG_IN' | translate }}</a>
    </div>
</ng-container>

<ng-container *ngIf="forgottenPassState === 'emailSent'">
    <div class="email-sent-pane shadow">
        <div class="letter-img"></div>
        <div [height]="33"></div>
        <div class="header-font centered-txt b1Color" i18n>{{ 'CHECK_YOUR_INBOX' | translate }}</div>
        <div [height]="25"></div>
        <div class="letter-sent-text" i18n>{{ 'IF_THE_EMAIL_ADDRESS' | translate }},</div>
        <div class="letter-sent-text" i18n>{{ 'YOU_WILL_RECEIVE_PASSWORD' | translate }}</div>
        <div [height]="25"></div>
        <div class="header-font centered-txt b1Color" style="font-size: 21px">{{ 'SENT_TO' | translate}} {{email}}</div>
        <div [height]="62"></div>
    </div>
    <div class="bottom-links-container">
        <a class="bottom-links" (click)="goToSignIn()" i18n>{{ 'LOG_IN' | translate }}</a>
    </div>
</ng-container>